import moment from 'moment';
import React from 'react';
import ReportDropDown from '../../components/reportDropDown';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {truBlueStatus, truBlueStatusFormat} from 'helpers/constants';

const statusAllKey = 'all';
const currentYear = new Date().getFullYear();

class ReportOptions extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      from: moment().startOf('year'),
      status: statusAllKey,
      store: 0,
      selectedYear: props.intl.formatMessage({id: 'general.date.ytd'}, {year: currentYear}),
      to: moment(),
    };
  }

  resetFilters = () => {
    const {formatMessage} = this.props.intl;

    this.setState({
      from: moment().startOf('year'),
      store: 0,
      to: moment(),
      selectedYear: formatMessage({id: 'general.date.ytd'}, {year: currentYear}),
      status: statusAllKey,
    });
  };

  updateData = () => {
    this.props.updateReportData(this.state.store, this.state.status === statusAllKey ? '' : this.state.status,
      this.state.from, this.state.to);
  };

  updateFilters = (data) => {
    const {formatMessage} = this.props.intl;

    if (data === currentYear) {
      this.setState({
        from: moment().startOf('year'),
        selectedYear: formatMessage({id: 'general.date.ytd'}, {year: currentYear}),
        to: moment(),
      });
    } else {
      this.setState({
        from: moment('1/1/' + data),
        selectedYear: data,
        to: moment('12/31/' + data),
      });
    }
  };

  render() {
    let stores = [];
    let truBlueStatusList = [];
    let years = [];
    let {formatMessage} = this.props.intl;
    let truBlueStatus = truBlueStatusFormat(formatMessage);

    truBlueStatusList = Object.keys(truBlueStatus).map(function(key) {
      return {value: key, label: truBlueStatus[key]};
    });
    truBlueStatusList.unshift({value: statusAllKey, label: formatMessage({id: 'general.all'})});

    if (this.props.branches !== null && this.props.branches !== undefined && this.props.branches.length > 0) {
      let obj = this.props.branches;

      stores = Object.keys(obj).map(function(key) { return {value: obj[key].id, label: obj[key].name}; });
      stores.unshift({value: 0, label: formatMessage({id: 'general.all.stores'})});
    }

    for (let x = currentYear; x >= 2010; x--) {
      if (x === currentYear) {
        years.push({value: x, label: formatMessage({id: 'general.date.ytd'}, {year: x})});
      } else {
        years.push({value: x, label: x});
      }
    }

    return (
      <div className="report-options">
        <div className="top-title-bar">
          <FormattedMessage id="general.report.options" />
        </div>
        <div className="select-options container">
          <div className="row">
            <div className="col-sm-3">
              <ReportDropDown value={this.state.selectedYear} label={formatMessage({id: 'general.select.year'})}
                onChange={((e) => {
                  this.updateFilters(e.target.value);
                })}
                options={years} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3">
              <ReportDropDown value={this.state.store} label={formatMessage({id: 'general.store'})}
                onChange={((e) => {
                  this.setState({store: e.target.value});
                })}
                options={stores} />
            </div>
            <div className="col-sm-3">
              <ReportDropDown value={this.state.status} label={formatMessage({id: 'general.trublue.status'})}
                onChange={((e) => {
                  this.setState({status: e.target.value});
                })}
                options={truBlueStatusList} />
            </div>
          </div>
        </div>
        <div className="manage-options">
          <div className="col-sm-12 button-group">
            <a className="reset-button pull-right" onClick={this.resetFilters}><FormattedMessage id="general.reset" /></a>
            <a className="btn btn-primary pull-right" onClick={this.updateData}><FormattedMessage id="reports.update.summary" /></a>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(ReportOptions);
